import Module from '../lib/module';

export default class CharacterCounter extends Module {
  setup() {
    this.input = this.element.querySelector('textarea, input[type=text]');
    this.limit = parseInt(this.element.getAttribute('data-character-limit'), 10);
    this.notice = document.createElement('small');
    this.notice.classList.add('form-text');
    this.notice.classList.add('text-muted');
    this.element.appendChild(this.notice);

    this.debouncedUpdateNotice = debounce((event) => {
      this._updateNotice(event);
    }, 100);

    this._updateNotice();
    this.bind();
  }

  bind() {
    this.on('input', 'textarea, input[type=text]', this.debouncedUpdateNotice);
  }

  unbind() {
    this.off('input', 'textarea, input[type=text]');
  }

  _updateNotice(event) {
    // Javascript counts line breaks as one char where on the server side
    // a line break is counted as two chars. That's why we subtract the
    // amount of line breaks manually.
    const typedChars = this.input.value.length;
    const lineBreaks = (this.input.value.match(/\n/g) || []).length
    const remainingChars = this.limit - (typedChars + lineBreaks);
    const word = remainingChars == 1 ? 'character' : 'characters';
    this.notice.textContent = `You have ${remainingChars} ${word} remaining.`;
  }
}

// Copied from https://www.joshwcomeau.com/snippets/javascript/debounce/
function debounce(callback, wait) {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback.apply(null, args);
    }, wait);
  };
}
